import { Component, inject, model } from '@angular/core';
import { ContractModel } from '../../shared/models/contract.model';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../../profile/services/profile.service';
import { ContractFormComponent } from "../contract-form/contract-form.component";
import { ContractService } from '../services/contract.service';
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-contract-edit',
  standalone: true,
  imports: [ContractFormComponent],
  templateUrl: './contract-edit.component.html',
  styleUrl: './contract-edit.component.css'
})
export class ContractEditComponent {
  private service = inject(ContractService);
  private route = inject(ActivatedRoute);
  protected access = inject(AccessService).access;

  protected id!: string | null;

  protected value = model<ContractModel | undefined>(undefined)

  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Editar Contrato')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.get(params.get('id'));
    });
  }

  private get(id: string | null) {
    console.log('getContract', id)
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      this.service.get(id).subscribe(data => {
        this.value.update(value => (value = data as ContractModel));
      });
    }
  }
}
